module.exports = __webpack_public_path__ + "img/obchod.1f8ddefa.png";